import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
type PlanId = 'standard' | 'pro';
const PLANS: Record<PlanId, {
  id: PlanId;
  name: string;
  items: string;
  oldPrice: string;
  price: string;
  url: string;
}> = {
  standard: {
    id: 'standard',
    name: 'TDAH EN CALMA',
    items: '6 tomos + 6 bonos',
    oldPrice: '$43.990',
    price: '$19.990',
    url: 'https://checkout.hacelohoy.shop/cart/43448889213041:1'
  },
  pro: {
    id: 'pro',
    name: 'MEGAPACK PRO',
    items: '8 tomos + 6 bonos',
    oldPrice: '$53.490',
    price: '$29.990',
    url: 'https://checkout.hacelohoy.shop/cart/43448894226545:1'
  }
};
export function PlanSelector() {
  const [selected, setSelected] = useState<PlanId>('pro');
  const handleBuy = () => {
    window.location.href = PLANS[selected].url;
  };
  return <div className="max-w-2xl mx-auto" data-id="element-277">
      <div className="flex flex-col gap-3 md:gap-4" data-id="element-278">
        {(['pro', 'standard'] as PlanId[]).map(id => {
        const plan = PLANS[id];
        const isSelected = selected === id;
        const isPro = id === 'pro';
        return <motion.button key={id} type="button" onClick={() => setSelected(id)} whileTap={{
          scale: 0.99
        }} aria-pressed={isSelected} className={`relative w-full flex items-center gap-3 md:gap-4 text-left rounded-2xl px-4 py-3 md:px-6 md:py-4 border-2 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E76F51] focus-visible:ring-offset-2 ${isPro ? isSelected ? 'bg-[#1E2A4A] border-[#E76F51] shadow-xl ring-2 ring-[#E76F51]/30' : 'bg-[#1E2A4A]/90 border-[#1E2A4A] shadow-md' : isSelected ? 'bg-white border-[#E76F51] shadow-lg ring-2 ring-[#E76F51]/30' : 'bg-[#FBF7F0] border-[#1E2A4A]/10'}`} data-id="element-279">
              {/* radio */}
              <span className={`shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'bg-[#E76F51] border-[#E76F51]' : isPro ? 'border-white/40' : 'border-[#1E2A4A]/30'}`} data-id="element-280">
                {isSelected && <Check size={14} className="text-white" data-id="element-281" />}
              </span>

              {/* name + items */}
              <div className="min-w-0 flex-1" data-id="element-282">
                <div className="flex items-center gap-2 flex-wrap" data-id="element-283">
                  <h3 className={`font-bold leading-tight text-sm md:text-lg ${isPro ? 'text-white' : 'text-[#1E2A4A]'}`} data-id="element-284">
                    {plan.name}
                  </h3>
                  {isPro && <span className="bg-yellow-400 text-yellow-900 text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1 shadow-sm whitespace-nowrap" data-id="element-285">
                      <Star size={9} className="fill-yellow-900" data-id="element-286" /> MÁS ELEGIDO
                    </span>}
                </div>
                <p className={`text-[11px] md:text-sm font-medium ${isPro ? 'text-[#E76F51]' : 'text-[#1E2A4A]/70'}`} data-id="element-287">
                  {plan.items}
                  {isPro && <span className="hidden sm:inline text-white/50" data-id="element-288">
                      {' '}
                      · incluye T7 y T8 exclusivos
                    </span>}
                </p>
              </div>

              {/* price */}
              <div className="shrink-0 text-right" data-id="element-289">
                <div className={`text-xl md:text-3xl font-extrabold leading-none ${isPro ? 'text-white' : 'text-[#1E2A4A]'}`} data-id="element-290">
                  {plan.price}
                </div>
                <div className={`text-[10px] md:text-xs line-through decoration-red-500 decoration-2 font-bold ${isPro ? 'text-white/40' : 'text-[#1E2A4A]/40'}`} data-id="element-291">
                  {plan.oldPrice}
                </div>
              </div>
            </motion.button>;
      })}
      </div>

      <motion.button type="button" onClick={handleBuy} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} className="mt-4 md:mt-6 w-full inline-flex items-center justify-center font-bold rounded-xl bg-[#E76F51] text-white hover:bg-[#d66245] py-4 md:py-5 text-base md:text-xl shadow-lg shadow-[#E76F51]/30 hover:shadow-[0_0_30px_rgba(231,111,81,0.5)] transition-all duration-200" data-id="element-292">
        💥 QUIERO MI MEGAPACK AHORA — {PLANS[selected].price}
      </motion.button>
    </div>;
}